// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation__navigation___sQB3R {
    overflow: hidden;
    padding: 0.8rem 1.2rem;

    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
    & .BreadcrumbsItem.Breadcrumbs-Item .Text {
        max-width: 25rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/Navigation/Navigation.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,sBAAsB;;IAEtB,uEAAuE;IACvE;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".navigation {\n    overflow: hidden;\n    padding: 0.8rem 1.2rem;\n\n    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n    & :global(.BreadcrumbsItem.Breadcrumbs-Item .Text) {\n        max-width: 25rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `Navigation__navigation___sQB3R`
};
export default ___CSS_LOADER_EXPORT___;
